import Cookies from "js-cookie";
import { ApiOrganizationUserType } from "../../hooks/entities/useOrganization";
import { DtoCreatedAndModifiedBy, ReducerCommandType, StringStringDictionary } from "../Types";
import { localStore } from "../io/localStore";

// ----------------------- Events -----------------------
const CHANGE_ORGANIZATION_RESET = "CHANGE_ORGANIZATION_RESET";
const CHANGE_ORGANIZATIONS_ALL = "CHANGE_ORGANIZATIONS_ALL";
const CHANGE_ORGANIZATIONS_LOADING_ORGANIZATIONS = "CHANGE_ORGANIZATIONS_LOADING_ORGANIZATIONS";
const CHANGE_ORGANIZATION_CURRENTORGANIZATION = "CHANGE_ORGANIZATION_CURRENTORGANIZATION";
const CHANGE_ORGANIZATIONS_MYROLES = "CHANGE_ORGANIZATIONS_MYROLES";
const CHANGE_ORGANIZATIONS_MYUSERS = "CHANGE_ORGANIZATIONS_MYUSERS";

const CHANGE_ORGANIZATION_PROJECTS = "CHANGE_ORGANIZATION_PROJECTS";
const CHANGE_ORGANIZATION_OFFERS = "CHANGE_ORGANIZATION_OFFERS";
const CHANGE_ORGANIZATION_PLANTASSORTMENT = "CHANGE_ORGANIZATION_PLANTASSORTMENT";


// ----------------------- Cookies -----------------------
export const COOKIENAME_CURRENT_ORGANIZATION_ID = "coid";


// ----------------------- Types -----------------------
// Reducer
export type organizationReducerType = {
    currentOrganization: OrganizationType | undefined | null,
    allOrganizations: { [key: string]: OrganizationType },
    loadingOrganizations: boolean,
    myRoles: { [key: string]: MyRolesType },
    myUsers: ApiOrganizationUserType[],
    myAdProjects: { [x: string]: AdProjectType },
    myOffers: { [x: string]: OrganizationOfferType },
    myPlantAssortment: StringStringDictionary,
}
export type MyRolesType = {
    added: number
    organizationId: string
    role: OrganizationUserRoleType
}
export type OrganizationUserRoleType = "OWNER" | "NONE" | "MEMBER" | "HIDDEN";
export type OrganizationProStatus = "basic" | "trial" | "pro";
// Other types
export type OrganizationType = {
    id?: string
    name?: string,
    contact?: string,
    address?: string,
    postalAddress?: string,
    organizationNumber?: string,
    billingEmail?: string,
    typeOfBusiness?: TypeOfBusinessType[],
    showOnMap?: boolean,
    locationLatitude?: number,
    locationLongitude?: number,
    organizationOwnerUserId?: string
    description?: string
    imageid?: string
    bgimageid?: string
    weburl?: string
    sys_datemodified_utc_epoch?: number
    trialexpires?: number
    premiumexpires?: number

    customerContactName?: string
    customerContactAddress?: string
    customerContactPhone?: string
    customerContactEmail?: string
    customerContactWeb?: string
    customerContactFacebook?: string
    customerContactInstagram?: string

    billingCustomerNumber?: string
    billingDiscount?: string
    billingNotes?: string
    billing?: string
    billingCurrency?: string
};

export type TypeOfBusinessType = "plants_and_garden" | "services" | "misc" | "local_growers";
// Ads
export type AdStateType = "active" | "for_review" | "draft" | "archived";

export type AdItemType = {
    label: string
    name: string
    clientId: string
    organizationId: string
    organizationName: string
    projectId: string
    type: AdItemTypeType
    published: boolean
    link: string
    linkText: string
    title01: string
    title02: string
    title03: string
    title04: string
    title05: string
    imageid: string
    imageUrl: string
    imageUrlThumb: string,
    plantIds: string
    startDateKey: number
    endDateKey: number
    adstate: AdStateType
    id: string
    sys_datemodified_utc_epoch: number
    sys_datecreated_utc_epoch: number,
    num_press: number,
    num_users_press: number,
    num_users_view: number,
    num_views: number,

    hasOfferDetails?: boolean
}
export type AdProjectType = {
    name: string
    organizationId: string
    organizationName: string
    adstate: AdStateType
    price: number
    hasinstagramstory: boolean
    hasinstagrampost: boolean
    hassponsoredpost: boolean
    hassponsoredblog: boolean
    haspushnotification: boolean

    instagramstory_num_press?: number
    instagramstory_num_views?: number
    instagrampost_num_press?: number
    instagrampost_num_views?: number
    sponsoredpost_num_press?: number
    sponsoredpost_num_views?: number
    sponsoredblog_num_press?: number
    sponsoredblog_num_views?: number
    pushnotification_num_press?: number
    pushnotification_num_views?: number

    startdatekey: number
    enddatekey: number
    deadlinedatekey: number
    packagename: string
    targetviews: number
    id: string
    imageid: string
    imageUrl: string
    imageUrlThumb: string
    sys_datecreated_utc_epoch: number
    sys_datemodified_utc_epoch: number,

    adLines: AdItemType[],

    adProjectUIState?: AdProjectUIState
}
export type AdProjectUIState = undefined | "drafting" | "upcoming" | "active" | "finished";
export type AdProjectResponseType = {
    adProjects: AdProjectType[],
    ads: AdItemType[]
}
export type AdItemTypeType = "" |
    // Plants
    "plantsearch" |
    "plantdetail_main" |
    "plantdetail_main_web" |

    // Forum-Feed
    "forum_feed" |

    // discovery
    "discovery_featured" |
    "discovery_featured_secondary" |
    "discovery_featured_plants" |

    "monthly_article" |
    // discovery
    "calendar_list" |

    // Erbjudande
    "offer";


export type OrganizationOfferType = DtoCreatedAndModifiedBy & {
    id: string,
    name: string,
    sorting: number,
    editing?: boolean,
    state: OrganizationOfferStateType,
    organizationId: string
    organizationName: string
    type: OrganizationOfferTypeType,

    title01: string,
    title02: string,
    title03: string,
    link: string,
    imageid: string
    imageUrl: string
    imageUrlThumb: string,
    hasOfferDetails?: boolean,
    boostedUntilDatekey?: number
}
export type OrganizationOfferStateType = "published" | "draft";
export type OrganizationOfferTypeType = "offer" | "selection";

// ----------------------- DefaultState -----------------------
const organizationReducerDefaultState: organizationReducerType = {
    currentOrganization: undefined,
    allOrganizations: {},
    loadingOrganizations: false,
    myRoles: {},
    myUsers: [],
    myAdProjects: {},
    myOffers: {},
    myPlantAssortment: {}
}
// ----------------------- Reducer -----------------------
const organizationReducer = (state = {
    ...organizationReducerDefaultState
}, action: ReducerCommandType) => {
    switch (action.type) {
        case CHANGE_ORGANIZATION_RESET: { state = { ...organizationReducerDefaultState }; break; }

        case CHANGE_ORGANIZATION_CURRENTORGANIZATION: {
            state = { ...state, currentOrganization: action.payload };
            Cookies.set(COOKIENAME_CURRENT_ORGANIZATION_ID, action.payload?.id, { expires: 365 });
            break;
        }
        case CHANGE_ORGANIZATIONS_ALL: { state = { ...state, allOrganizations: action.payload }; break; }
        case CHANGE_ORGANIZATIONS_LOADING_ORGANIZATIONS: { state = { ...state, loadingOrganizations: action.payload }; break; }

        case CHANGE_ORGANIZATIONS_MYROLES: { state = { ...state, myRoles: action.payload }; break; }
        case CHANGE_ORGANIZATIONS_MYUSERS: { state = { ...state, myUsers: action.payload }; break; }
        case CHANGE_ORGANIZATION_PROJECTS: { state = { ...state, myAdProjects: action.payload }; break; }
        case CHANGE_ORGANIZATION_OFFERS: { state = { ...state, myOffers: action.payload }; break; }
        case CHANGE_ORGANIZATION_PLANTASSORTMENT: { state = { ...state, myPlantAssortment: action.payload }; break; }

        default: { return state; }
    }
    localStore.setObject(localStore.keys.organizationKey, state)
    return state;
};



// ----------------------- Export -----------------------
export {
    organizationReducer,
    CHANGE_ORGANIZATION_RESET,
    CHANGE_ORGANIZATIONS_ALL,
    CHANGE_ORGANIZATIONS_LOADING_ORGANIZATIONS,
    CHANGE_ORGANIZATION_CURRENTORGANIZATION,
    CHANGE_ORGANIZATIONS_MYROLES,
    CHANGE_ORGANIZATIONS_MYUSERS,
    CHANGE_ORGANIZATION_PROJECTS,
    CHANGE_ORGANIZATION_OFFERS,
    CHANGE_ORGANIZATION_PLANTASSORTMENT,
}